import AccessControls from "@/components/call/access-controls";
import AgentParty from "@/components/call/call-header/agent";
import IntercomParty from "@/components/call/call-header/intercom";
import UnknownParty from "@/components/call/call-header/unknown";
import UserParty from "@/components/call/call-header/user";
import Cameras from "@/components/call/cameras";
import Contacts from "@/components/call/contacts";
import Procedures from "@/components/call/procedures";
import { ButtonCall, CallDetails, useGetCallHistoryEntry } from "@EspaceParkQC/sdk-call-center";
import { Button, ScrollArea, Sheet, SheetContent, SheetOverlay } from "@EspaceParkQC/sdk-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";

export default function History() {
  const { t } = useTranslation("main");
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const hid = searchParams.get("hid") ?? undefined;
  const { entry: callHistoryEntry } = useGetCallHistoryEntry(hid);

  useEffect(() => {
    setOpen(Boolean(hid));
  }, [hid]);

  const extensionNumber = callHistoryEntry?.extension;

  return (
    <Sheet open={open} onOpenChange={(open) => !open && setSearchParams({})}>
      <SheetOverlay>
        <SheetContent className="w-full p-0" style={{ maxWidth: "1600px" }}>
          <ScrollArea className="h-full p-4 mt-12">
            {extensionNumber && (
              <CallDetails
                extensionNumber={extensionNumber}
                render={({ intercomPartyDetails, agentPartyDetails, userPartyDetails, unknownPartyDetails }) => {
                  if (intercomPartyDetails) {
                    return (
                      <Fragment>
                        <ButtonCall
                          targetExtension={Number(callHistoryEntry?.extension)}
                          render={({ onClick, isAvailable }) => (
                            <div className="flex items-center gap-4">
                              <Button
                                className="ml-6 w-fit"
                                disabled={!isAvailable}
                                onClick={() => {
                                  onClick();
                                  setOpen(false);
                                }}
                              >
                                {t("history.call-back")}
                              </Button>
                              {intercomPartyDetails.hasVideo ? (
                                <p className="text-xs text-muted-foreground">
                                  <i>{t("history.call-back-to-reactivate-video-stream")}</i>
                                </p>
                              ) : null}
                            </div>
                          )}
                        />
                        <div className="space-y-6 md:p-6 p-3 pt-0 grow mx-auto" style={{ maxWidth: "1600px" }}>
                          <IntercomParty intercomPartyDetails={intercomPartyDetails} />
                          <div className="flex md:flex-row nowrap flex-col gap-6">
                            <AccessControls intercomPartyDetails={intercomPartyDetails} />
                            <Cameras />
                          </div>
                          <div className="flex md:flex-row flex-col gap-6">
                            <Procedures />
                            <Contacts />
                          </div>
                        </div>
                      </Fragment>
                    );
                  } else if (agentPartyDetails) {
                    return <AgentParty agentPartyDetails={agentPartyDetails} />;
                  } else if (userPartyDetails) {
                    return <UserParty userPartyDetails={userPartyDetails} />;
                  } else if (unknownPartyDetails) {
                    return <UnknownParty unknownPartyDetails={unknownPartyDetails} />;
                  } else {
                    return <Fragment />;
                  }
                }}
              />
            )}
          </ScrollArea>
        </SheetContent>
      </SheetOverlay>
    </Sheet>
  );
}
